import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-print1",
  "use": "icon-print1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-print1\"><defs><style type=\"text/css\"></style></defs><path d=\"M810.666667 341.333333l-597.333333 0c-70.613333 0-128 57.386667-128 128l0 256 170.666667 0 0 170.666667 512 0 0-170.666667 170.666667 0 0-256c0-70.613333-57.386667-128-128-128zM682.666667 810.666667l-341.333333 0 0-213.333333 341.333333 0 0 213.333333zM810.666667 512c-23.68 0-42.666667-18.986667-42.666667-42.666667s18.986667-42.666667 42.666667-42.666667c23.68 0 42.666667 18.986667 42.666667 42.666667s-18.986667 42.666667-42.666667 42.666667zM768 128l-512 0 0 170.666667 512 0 0-170.666667z\" p-id=\"3276\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/print1.svg
// module id = sJCI
// module chunks = 31